module.exports = __webpack_public_path__ + "img/bubble.e15e432f.png";